import Alert from 'features/shared/alerts/components/Alert';
import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  createRequirementHandler: () => Promise<void>;
}

const ReservedCapacityValidationSubDialog = ({ createRequirementHandler }: Props) => {
  // translations
  const tLabels = useTranslation(["shared\\terms"]).t;
  const t = useTranslation("requirements\\requirements").t;

  // DI
  const dialogService = useInjection<IContentDialogService>(IocTypes.ContentDialogService);

  // handlers
  const closeDialogHandler = () => {
    dialogService.closeDialog();
  }
  
  const confirmSendHandler = () => {
    closeDialogHandler();
    createRequirementHandler();
  }

  // render
  return (
    <>
      <div className="p-4">
        <Alert alertObj={{ alertType: "Warning", message: t("reservedCapacityValidationSubDialog.errorMessage") }} showIconOnMobile={false} />
      </div>
      <div className="d-flex justify-content-end px-4 pb-4">
        <button className="btn btn-outline-secondary px-4" onClick={closeDialogHandler}>
          {tLabels("No")}
        </button>
        <button className="btn btn-primary ml-2 px-4" onClick={confirmSendHandler}>
          {tLabels("Yes")}
        </button>
      </div>
    </>
  )
}

export default ReservedCapacityValidationSubDialog;
